var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import './EventsControlPage.scss';
import InputSearch from '@/components/InputSearch/InputSearch';
import AddIcon from '@assets/svg/addIcon.svg';
import { useAppSelector, useDebounce } from '@/hooks/redux';
import { useGetEventsPublicQuery, useDeleteEventMutation, useSetEventPinnedMutation } from '@/services/eventsApi';
import { useGetCitiesQuery } from '@/services/citiesApi';
import EventItem from './EventItem/EventItem';
import { useNavigate } from 'react-router-dom';
import Loader from '@/components/Loader/Loader';
import SelectStatistics from '../StatisticsPage/Select/Select';
var EventsControlPage = function () {
    var _a = useState(''), search = _a[0], setSearch = _a[1];
    var _b = useState(), selectedCityId = _b[0], setSelectedCityId = _b[1];
    var user = useAppSelector(function (state) { return state.authStich.currentUser; });
    var isSuperAdmin = (user === null || user === void 0 ? void 0 : user.role) === 'системный администратор';
    var isManager = (user === null || user === void 0 ? void 0 : user.role) === 'системный менеджер';
    var _c = useGetEventsPublicQuery({ cityId: selectedCityId }), eventsData = _c.data, isEventsLoading = _c.isLoading, refetch = _c.refetch;
    // Отладка
    console.log('Query params:', { cityId: selectedCityId });
    console.log('Events data:', eventsData);
    var cities = useGetCitiesQuery().data;
    useEffect(function () {
        if (user) {
            refetch();
        }
    }, [search, selectedCityId]);
    var _d = useDeleteEventMutation(), deleteEvent = _d[0], isDeleting = _d[1].isLoading;
    var setPinned = useSetEventPinnedMutation()[0];
    var navigate = useNavigate();
    var goToCreateEvent = function () {
        navigate('/events/create');
    };
    var goToEditEvent = function (event) {
        navigate("/events/edit/".concat(event.id));
    };
    var debouncedSetSearchText = useDebounce(function (text) {
        setSearch(text);
    }, 300);
    var handleDelete = function (id) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.confirm('Вы уверены, что хотите удалить это событие?'))
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, deleteEvent(id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    var handleSetPinned = function (id) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.confirm('Закрепить это событие? Другие события потеряют статус закрепленного.'))
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, setPinned(id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    // Фильтрация событий
    var filteredEvents = (eventsData === null || eventsData === void 0 ? void 0 : eventsData.filter(function (event) {
        var matchesSearch = !search || (event.title && event.title.toLowerCase().includes(search.toLowerCase()));
        return matchesSearch;
    })) || [];
    var handleCityChange = function (selectedOption) {
        var cityName = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.restaurant) || selectedOption;
        if (cityName === 'Все города') {
            setSelectedCityId(undefined);
        }
        else {
            var city = cities === null || cities === void 0 ? void 0 : cities.find(function (c) { return c.name === cityName; });
            setSelectedCityId(city === null || city === void 0 ? void 0 : city.id);
        }
    };
    // Список городов для фильтра
    var cityOptions = __spreadArray(['Все города'], ((cities === null || cities === void 0 ? void 0 : cities.map(function (city) { return city.name; })) || []), true);
    return (_jsxs("div", __assign({ className: 'EventsControlPage' }, { children: [_jsx(PageHeader, { children: _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '24px' } }, { children: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F\u043C\u0438 \"\u041A\u0443\u0434\u0430 \u0441\u0445\u043E\u0434\u0438\u0442\u044C\"" })) }), _jsxs("div", __assign({ style: { padding: '40px', width: '100%', boxSizing: 'border-box' } }, { children: [_jsxs("div", __assign({ style: { display: 'flex', gap: '16px', marginBottom: '24px', flexWrap: 'wrap' } }, { children: [_jsx(InputSearch, { setSearch: debouncedSetSearchText }), _jsx(SelectStatistics, { data: cityOptions, setItem: handleCityChange })] })), _jsx(AddIcon, { onClick: goToCreateEvent, style: { marginBottom: '24px', cursor: 'pointer' } }), isEventsLoading ? (_jsx(LoaderContainer, { children: _jsx(Loader, { width: '50px', height: '50px' }) })) : (_jsx("div", __assign({ style: { marginTop: '20px' } }, { children: filteredEvents.length ? (filteredEvents
                            .map(function (event, index) { return (_jsx(EventItem, { onClick: function () { return goToEditEvent(event); }, event: event, onDelete: function () { return handleDelete(event.id); }, onSetPinned: function () { return handleSetPinned(event.id); }, isFirst: index === 0, isLoading: isDeleting, isLast: index === filteredEvents.length - 1 }, event.id)); })) : (_jsxs(EventsList, { children: [_jsx(EmptyList, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 400, fontSize: '16px' } }, { children: "\u0417\u0434\u0435\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0441\u044F \u0441\u043F\u0438\u0441\u043E\u043A \u0441\u043E\u0431\u044B\u0442\u0438\u0439" }))] })) })))] }))] })));
};
var PageHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: #fff;\n  width: 100%;\n  padding-top: 43px;\n  padding-left: 40px;\n  padding-bottom: 27px;\n  box-sizing: border-box;\n\n  @media (max-width: 800px) {\n    height: 150px;\n    padding-top: 90px;\n  }\n"], ["\n  background: #fff;\n  width: 100%;\n  padding-top: 43px;\n  padding-left: 40px;\n  padding-bottom: 27px;\n  box-sizing: border-box;\n\n  @media (max-width: 800px) {\n    height: 150px;\n    padding-top: 90px;\n  }\n"])));
var EventsList = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var EmptyList = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 24px;\n  text-align: center;\n  margin: 20px 0;\n"], ["\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 24px;\n  text-align: center;\n  margin: 20px 0;\n"])));
var LoaderContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"])));
var PaginationContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"])));
var ChangePageButton = styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"], ["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"])));
export default EventsControlPage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
